'use client';

import { useIntl } from 'react-intl';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { addReviewCallToActionMessages } from './AddReviewCallToAction.messages';

/* "!box-content" is needed because an inline star selector overwrites box-sizing with "inherit" */
const roundedClasses = 'h-4 w-4 rounded-full border p-2 border-color-grey-dark !box-content';

export type AddReviewCallToActionProps = {
  /* 
    onAction - handler function that will be executed after a component action
  */
  onAction: () => void;
  /* 
    isLoading - indicates if the component should be rendered in loading state (Skeleton mode)
  */
  isLoading?: boolean;
};

/**
 * The AddReviewCallToAction component is used to display a call to action for the user
 * to write a new rating/review
 */
export const AddReviewCallToAction = ({
  onAction,
  isLoading = false,
}: AddReviewCallToActionProps) => {
  const { formatMessage } = useIntl();

  const handleAction = () => {
    if (typeof onAction === 'function') {
      onAction();
    }
  };

  return (
    <div className="border-color-grey flex flex-col items-center justify-center gap-1 rounded-sm border border-dashed px-1.5 pt-4 pb-3">
      <button
        onClick={handleAction}
        type="button"
        className="group flex flex-col items-center gap-1"
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <Skeleton className={roundedClasses} />
            <Skeleton className="h-3 w-[10rem]" />
          </>
        ) : (
          <>
            <span className={`${roundedClasses} group-hover:bg-color-grey-light block`}>
              <span className="icon-emp-plus h-4 w-4" />
            </span>
            <span>{formatMessage(addReviewCallToActionMessages.text)}</span>
          </>
        )}
      </button>
    </div>
  );
};
